import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "@mui/material";
import { SET_SUCCESS_PROMPT_CMS_PAGE } from "../../../store/actionTypes/cmsActionType";

const ContentTemplateSuccessPrompt = () => {
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation();

  const {
    isSuccessPromptCMSPage: isSuccess,
    successMessageCMSPage: successMessage,
  } = useSelector((state) => state.cms);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_SUCCESS_PROMPT_CMS_PAGE, payload: false });
  };

  return (
    isSuccess && (
      <Alert
        sx={{ my: 2 }}
        severity="success"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{tCommon("successPromptTitle")}</AlertTitle>
        {successMessage}
      </Alert>
    )
  );
};

export default ContentTemplateSuccessPrompt;
